@if (isOpen) {
  <app-popup-layout [showTopBand]="true">
    <article
      class="submitted-popup-card relative w-full max-w-3xl overflow-hidden bg-white px-4 py-6 shadow-2xl sm:px-8 sm:py-8"
      aria-labelledby="submitted-popup-title">
      <div class="pointer-events-none absolute inset-x-0 bottom-0 h-24 submitted-popup-glow" aria-hidden="true"></div>

      <div class="relative z-10 flex flex-col items-center text-center">
        <div class="submitted-check-icon flex h-20 w-20 items-center justify-center rounded-full bg-mock-green-400">
        <img [src]="imageEnum.CHECK_ICON" alt="check.svg">
        </div>

        <h2 id="submitted-popup-title" class="submitted-popup-title font-inter text-text-primary mt-5">
          {{ isInProgress ? 'Progress Saved' : 'Examination Submitted Successfully' }}
        </h2>
        <p class="submitted-popup-description font-inter text-text-secondary mt-2">
          @if (isInProgress) {
            Your progress has been saved. The exam timer keeps running, so resume before your total exam duration ends or it will be auto-submitted.
          } @else {
            Your responses have been successfully recorded. Review your performance below.
          }
        </p>

        @if (testName) {
          <p class="submitted-test-name mt-4 text-base font-semibold text-text-primary">{{ testName }}</p>
        }
        @if (submissionTime) {
          <p class="submitted-time mt-1 text-sm text-text-secondary">
            {{ isInProgress ? 'Saved on' : 'Submitted on' }}: {{ formatDisplayDateTime(submissionTime) }}
          </p>
        }

        <div class="submitted-stats-grid mt-6 grid w-full grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
          @for (card of statCards; track card.id) {
            <section class="submitted-stat-card rounded-xl py-4 max-w-xs sm:max-w-sm text-center" [class]="'submitted-stat-card tone-' + card.tone">
              <div class="submitted-stat-icon mx-auto flex h-9 w-9 items-center justify-center rounded-xl" [class]="'submitted-stat-icon tone-' + card.tone">
                <img [src]="card.icon" [alt]="">
              </div>

              <p class="secondary-label font-inter mt-1.5">{{ card.label }}</p>
              <p class="submitted-stat-value sm:my-2 font-inter" [class]="'tone-text-' + card.tone">{{ card.value }}</p>
              <p class="sub-paragraph font-inter">{{ card.helperText }}</p>
            </section>
          }
        </div>

        <div class="submitted-actions mt-6 grid w-full grid-cols-1 gap-4" [class.md:grid-cols-2]="!isInProgress">
          <app-outline-button
            text="Back to Dashboard"
            ariaLabel="Back to dashboard"
            buttonClass="w-full rounded-xl border-brand-primary py-3 text-base font-semibold tracking-normal"
            (buttonClick)="onBackToDashboard()" />

          @if (!isInProgress) {
            <div class="relative w-full" [class.group]="isReviewLocked">
              <app-primary-button
                text="View Result"
                ariaLabel="View result"
                [buttonClass]="isReviewLocked
                  ? 'w-full rounded-xl py-3 text-base font-semibold tracking-normal !bg-slate-100 !bg-none border border-slate-200 !text-slate-400 cursor-not-allowed'
                  : 'w-full rounded-xl py-3 text-base font-semibold tracking-normal'"
                (buttonClick)="onViewResult()" />
              <div
                class="pointer-events-none invisible absolute bottom-full left-1/2 z-[999] mb-2 w-max max-w-64 -translate-x-1/2 opacity-0 transition-all duration-200 group-hover:visible group-hover:opacity-100"
                [class.visible]="isTooltipVisible()"
                [class.opacity-100]="isTooltipVisible()">
                <div class="rounded-xl border border-indigo-100 bg-white px-3 py-2 text-xs font-medium leading-4 text-slate-700 shadow-xl">
                  {{ reviewLockedMessage }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </article>
  </app-popup-layout>
}
